import { Grid } from "@mui/material";
import React, { useState, useEffect } from "react";
import { InputField } from "../../../../../library/custom/textBox/InputField";
import Checkbox from "../../../../../library/checkbox/checkbox";

const SiteCompliance = (props) => {
  const [
    swInspectionSiteComplianceChecked,
    setSwInspectionSiteComplianceChecked,
  ] = useState(false);

  useEffect(() => {
    if (props?.swInspectionSiteCompliance) {
      const anyChecked = props?.swInspectionSiteCompliance.some(
        (item) => item.siteAns
      );
      setSwInspectionSiteComplianceChecked(anyChecked);
    }
  }, [props?.swInspectionSiteCompliance]);

  const siteComplianceHandler = (isChecked, siteComplianceData) => {
    const isCheckedValue = isChecked;
    props?.setSwInspectionSiteCompliance((prevState) => {
      const existingIndex = prevState.findIndex(
        (item) =>
          (item.key || item.itemId) ===
          (siteComplianceData.key || siteComplianceData.itemId)
      );

      if (existingIndex !== -1) {
        const updatedData = [...prevState];

        updatedData[existingIndex] = {
          ...updatedData[existingIndex],
          itemId: siteComplianceData?.key,
          siteAns: isCheckedValue,
        };

        return updatedData;
      }

      return prevState;
    });
  };
  return (
    <>
      <Grid container>
        <Grid item md={12} className="northCarolinaOverride" mt={2}>
          <div className="commonTableBoxNorth">
            <table>
              <tr className="tableHead">
                <th className="sixty">
                  Check the box if the following items are on-site:
                  <span className="error">*</span>
                </th>
              </tr>
              {props?.swInspectionSiteCompliance?.map(
                (siteCompliance, index) => {
                  const isLastItem =
                    index === props?.swInspectionSiteCompliance.length - 1;

                  return (
                    <tr
                      className="tableBody"
                      key={siteCompliance?.key || siteCompliance?.itemId}
                    >
                      <td className="projectPhaseLeft tennesse">
                        <div className="left">
                          {siteCompliance?.value || siteCompliance?.optionName}
                        </div>
                        <div className="right">
                          {isLastItem ? (
                            <InputField
                              isRequired={false}
                              type="text"
                              placeholder={""}
                              value={siteCompliance?.siteComment || ""}
                              onChange={(e) => {
                                const updatedValue = e.target.value;
                                props?.setSwInspectionSiteCompliance(
                                  (prevState) => {
                                    const updatedState = [...prevState];
                                    updatedState[index] = {
                                      ...updatedState[index],
                                      itemId:
                                        siteCompliance?.key ||
                                        siteCompliance?.itemId,
                                      siteComment: updatedValue,
                                    };
                                    return updatedState;
                                  }
                                );
                              }}
                            />
                          ) : (
                            <Checkbox
                              checked={siteCompliance?.siteAns}
                              onChange={(e) =>
                                siteComplianceHandler(
                                  e.target.checked,
                                  siteCompliance
                                )
                              }
                              label={""}
                            />
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                }
              )}
            </table>
          </div>
        </Grid>
        <Grid md={12} item mb={2}>
          {props?.siteComplianceError && !swInspectionSiteComplianceChecked && (
            <p className="error">Please select at least one Checkbox.</p>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default SiteCompliance;
